<template>
  <form class="c-form-workspace-create" @submit.prevent="onSubmit">
    <Form
      ref="form"
      :schema="computedSchema"
      v-model="currentForm"
      @status="saveStatus"
      buttonText="Create your workspace"
      :processing="processing"
    ></Form>
  </form>
</template>

<script>
import Form from "./index.vue";

let schema = {
  name: {
    component: "InputText",
    label: "Your workspace name",
    description: "Eg: your company name.",
    validations: {
      required: {
        params: null,
        message: "A workspace name is required",
      },
      minLength: {
        params: 2,
        message: "Give a descriptive name. Minimum 2 characters",
      },
      maxLength: {
        params: 64,
        message: `That's a insanely long name. Maximum 64 characters`,
      },
    },
  },
  logo: {
    component: "InputUpload",
    label: "Workspace Logo",
    description: "Optional - you can upload one later",
    validations: {},
  },
};

export default {
  components: {
    Form,
  },

  data: function () {
    return {
      processing: false,
      currentForm: {
        id: null,
        name: "",
        logo: "",
      },
      status: null,
    };
  },

  props: {
    form: {
      type: Object,
      default: function () {
        return {
          id: null,
          name: "",
          logo: "",
        };
      },
    },
  },

  computed: {
    computedSchema: function () {
      let s = schema;
      let user = this.user;
      if (user.type === "ADMIN") {
      }

      return s;
    },
    user: function () {
      return this.$store.getters["users/user"];
    },
    schema: function () {
      let s = schema;

      return s;
    },
  },

  methods: {
    saveStatus: function (saveStatus) {
      this.status = saveStatus;
    },
    async onSubmit() {
      this.$refs.form.validate();

      if (this.status.invalid) {
        return;
      }

      this.processing = true;

      let form = this.currentForm;

      form = {
        id: form.id,
        name: form.name,
        logo: form.logo,
      };

      let formData = new FormData();

      formData.append("id", form.id);
      formData.append("name", form.name);
      formData.append("logo", form.logo);

      let response = await this.$store.dispatch("workspaces/update", formData);
      this.$emit("onSubmit");
      this.processing = false;
    },
  },

  created: function () {
    this.currentForm = {
      id: this.form.id,
      name: "",
      logo: "",
    };
  },
};
</script>

<style></style>
